import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

import Navigation from './Navigation';
import Item from './Item';
import Results from './Results';
import * as actions from '../actions';

const styles = (theme) => ({
	content: {
		position: 'relative',
	}
});

class ExerciseInterface extends Component {
	constructor(props) {
		super(props);
		this.onNext = this.onNext.bind(this);
		this.onBack = this.onBack.bind(this);
	}

	onNext() {
		const { currentItem, itemsLength, goToNextItem, showResults } = this.props;

		if (currentItem === itemsLength - 1) {
			showResults();
		} else {
			goToNextItem();
		}
	}

	onBack() {
		const { goToPreviousItem } = this.props;

		goToPreviousItem();
	}

	renderItems() {
		return this.props.items.map((item, i) => {
			const { display, question, answer, itemIndex } = item;
			return <Item key={itemIndex} index={i} question={display ? display[0]._ : question[0]._} answers={answer} />;
		});
	}

	renderContent() {
		const { classes, resultsVisible } = this.props;

		return (
			<div>
				<div style={{ display: resultsVisible ? 'none' : 'block' }}>
					<div className={classes.content}>
						{this.renderItems()}
					</div>
				</div>
				{resultsVisible && <Results />}
			</div>
		);
	}

	render() {
		return (
			<div>
				{this.renderContent()}
				<Navigation onBack={this.onBack} onNext={this.onNext} />
			</div>
		);
	}
}

ExerciseInterface.propTypes = {
	classes: PropTypes.object.isRequired,
	items: PropTypes.array.isRequired,
	goToPreviousItem: PropTypes.func.isRequired,
	goToNextItem: PropTypes.func.isRequired,
	showResults: PropTypes.func.isRequired,
	resultsVisible: PropTypes.bool.isRequired,
	currentItem: PropTypes.number.isRequired,
	itemsLength: PropTypes.number.isRequired,
};

function mapStateToProps({ exercise }) {
	return {
		resultsVisible: exercise.resultsVisible,
		currentItem: exercise.currentItem,
		itemsLength: exercise.items.length
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps, actions)
)(ExerciseInterface);
